import type { FC } from "react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { uuidv4 } from "../../utils/uuid";

const NewMomentPage: FC<{ newsletter?: boolean }> = ({ newsletter }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const route = `/moments/${uuidv4()}${newsletter ? "/newsletter" : ""}?${searchParams.toString()}`;

  useEffect(() => {
    void navigate(route, { replace: true });
  }, [route, navigate]);

  return null;
};

export default NewMomentPage;
